import "./WhoWeAre.css";

const boardMembers = [
  {
    name: "Mariah A.",
    title: "Founder",
    bio: `Mariah became a mother in 2024 when her first child was born prematurely at 34 weeks due to preeclampsia, followed by a lengthy NICU stay. 
      During those early days, she struggled to navigate what motherhood looked like under circumstances she had never anticipated. Finding clothes 
      small enough to fit her baby, bottles she could drink from, and pacifiers that would fit comfortably in her mouth all while balancing pumping schedules and meals, felt overwhelming, and that 
      was before confronting the paperwork, insurance complications, and seven-figure hospital bills.
      .
  `,
    bioCont: `In 2025, Mariah welcomed her second premature baby, born at 33 weeks and requiring an even longer NICU stay. 
      Although she felt more prepared the second time, the experience reinforced how isolating and difficult the NICU journey can be, even for families who have been through it before.
      Mariah knew she would always be part of the community of NICU parents, nurses, volunteers, and advocates who had shaped her family’s story. She also knew that one day, 
      she would find a meaningful way to give back.`,
    photo: `/assets/mariah.jpeg`
  },
  {
    name: "Fallon Rodrigues",
    title: "Founder",
    bio: `Fallon became a mother in March 2023 when her daughter was born at 36 weeks after she stopped growing and turned breech. Although her daughter did not require a NICU stay, those first days and months were filled with many of the same emotions so many families experience when a baby arrives earlier or under circumstances they never anticipated. The worry of whether her baby was okay, the challenges of breastfeeding, and the uncertainty that came with each new day made those early moments of motherhood feel very different from what she had imagined.`,
    bioCont: `Not being able to experience those first moments the way she had envisioned (from immediate skin-to-skin to confidently knowing that her baby was okay) left a lasting impact on her. She learned firsthand how overwhelming, isolating, and emotional those early months can be, even when your baby is home with you. Fallon’s experience gave her a deep appreciation for the parents navigating unexpected beginnings and the people who support them along the way. She knew she wanted to turn her own experience into something meaningful: to help other families feel less alone, more supported, and reminded that they are not navigating those moments by themselves.`,
    photo: `/assets/mamababybug.png`
  }
];

export default function WhoWeAre() {
  return (
    <div className="who-we-are">
      <section className="page-hero">
        <div className="container">
          <h1>Our founders</h1>
          <p>Meet the board members behind The Bug and Frog Foundation.</p>
        </div>
      </section>

      <section>
        <div className="container board-grid">
          {boardMembers.map((member) => (
            <div className="board-card" key={member.name}>
              <div className="board-photo">
                {member.photo ? (
                  <img src={member.photo} alt={member.name} />
                ) : (
                  <div className="board-photo-placeholder">Photo</div>
                )}
              </div>
              <h3>{member.name}</h3>
              <p className="board-title">{member.title}</p>
              <div className="board-bio">{member.bio}</div>
              <div className="board-bio bio-cont">{member.bioCont}</div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
